import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from './components/ui/sonner';
import HomePageWrapper from './pages/HomePagePremium';

function AppHomepage() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <HomePageWrapper portalUrl="https://portal.tridevlogistics.com" />
          <Toaster richColors position="top-right" />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default AppHomepage;
